module.exports = __webpack_public_path__ + "img/bookingimg.2a96b404.png";